// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"2df77d16","453":"e953ad80"}[chunkId] + ".chunk.js";
};